import { render, staticRenderFns } from "./submit_form.vue?vue&type=template&id=58832c84&scoped=true"
import script from "./submit_form.vue?vue&type=script&lang=js"
export * from "./submit_form.vue?vue&type=script&lang=js"
import style0 from "./submit_form.vue?vue&type=style&index=0&id=58832c84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58832c84",
  null
  
)

export default component.exports